import animationsUtility from '../utility/animations.js';

const splitIntoChars = (element) => {
    const text = element.innerText
    element.innerHTML = text
        .split("")
        .map((char, index) =>
            char === " "
                ? `<span class="char space">&nbsp</span>`
                : index === 0
                    ? `<span class="char first">${char}</span>`
                    : `<span class="char">${char}</span>`
        )
        .join("")
}

const init = () => {
    const collaborators = document.querySelectorAll(".tc-website-collaborator")

    collaborators.forEach((collaborator) => {
        collaborator.querySelectorAll('.back .main-skill>span').forEach((span) => {
            splitIntoChars(span)
        })

        collaborator.addEventListener('click', () => {
            collaborator.classList.toggle('show-details')
        })

        animationsUtility.animateCollaboratorsGrid(collaborator)
    })
}

export default {init};
